import axios from 'axios'
import Immutable from 'immutee'

import { getApiUrl, hasPandora } from '../utils/utils'

export const FETCH_REPORT = 'buyer/report/FETCH_REPORT'
export const FETCH_REPORT_FAILURE = 'buyer/report/FETCH_REPORT_FAILURE'

const initialState = {
  fetched: false,
  result: [],
  error: null,
}

export default function reducer(state = initialState, action) {
  const immutable = Immutable(state)
  switch (action.type) {
    case FETCH_REPORT:
      return immutable.set('fetched', true).done()

    case FETCH_REPORT_FAILURE:
      return immutable
        .set('error', action.payload)
        .set('result', [])
        .set('fetched', false)
        .done()

    default:
      return state
  }
}

export function fetchReport(data) {
  const url = `${getApiUrl()}detail/report`
  const pandora = hasPandora()
  const requestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
  }
  const requestData = {
    ...data,
    pandora,
  }
  return dispatch => {
    return axios
      .post(url, requestData, requestConfig)
      .then(res => {
        dispatch({
          type: FETCH_REPORT,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_REPORT_FAILURE,
          payload: err.stack,
        })
      })
  }
}
